import React from 'react'
import Icon from '@material-ui/core/Icon'
import withStyles from '@material-ui/core/styles/withStyles'

export default withStyles(({ spacing: { unit } }) => ({
  root: { marginLeft: -unit * 0.5, marginRight: unit * 0.5 },
}))(({ classes, ...rest }) => <Icon className={classes.root} {...rest} />)
